const resource = 'products';

export default $axios => ({
    getProducts(params = {}) {
        return $axios.get(`/${resource}`, { params });
    },
    // new for MP
    getProduct(id, params = {}) {
        return $axios.get(`/${resource}/${id}`, { params });
    },
    createProduct(data) {
        return $axios.post(`/${resource}`, data);
    },
    updateProduct(id, data) {
        return $axios.put(`/${resource}/${id}`, data);
    },
    addUpdateProductToCampaign(product, campaign, params = {}) {
        return $axios.post(
            `/${resource}/${product}/campaigns/${campaign}`,
            params
        );
    },
    getProductMedia(productId) {
        return $axios.get(`/${resource}/${productId}/media`);
    },
    assignProductMedia(productId, mediaData) {
        return $axios.post(`/${resource}/${productId}/media`, {
            media_id: mediaData.id,
            location: mediaData.location,
        });
    },
    updateProductMedia(productId, assignmentId, mediaData) {
        return $axios.put(`/${resource}/${productId}/media/${assignmentId}`, {
            media_id: mediaData.id,
            location: mediaData.location,
        });
    },
    deleteProductMedia(productId, id) {
        return $axios.delete(`/${resource}/${productId}/media/${id}`);
    },
    getProductTickets(productId) {
        return $axios.get(`/${resource}/${productId}/tickets`);
    },
    getProductTicket(productId, ticketId) {
        return $axios.get(`/${resource}/${productId}/tickets/${ticketId}`);
    },
    updateProductTicket(productId, ticketId, ticket) {
        return $axios.put(
            `/${resource}/${productId}/tickets/${ticketId}`,
            ticket
        );
    },
    createProductTicket(productId, ticket) {
        return $axios.post(
            `/${resource}/${productId}/tickets`,
            ticket
        );
    },
});